export const primary = {
  A200: '#4e9ef4',
  A100: '#51a7f5',
  900: '#0053CB',
  800: '#1565C0',
  700: '#1976D2',
  600: '#1E88E5',
  500: '#2196F3',
  400: '#42A5F5',
  300: '#64B5F6',
  200: '#90CAF9',
  100: '#BBDEFB',
  50: '#E3F2FD',
}

export const secondary = {
  A200: '#ef4876',
  A100: '#ef5882',
  900: '#8D2354',
  800: '#B32B5D',
  700: '#C82F61',
  600: '#Df3466',
  500: '#F0386A',
  400: '#F24F7F',
  300: '#F66C96',
  200: '#F896B4',
  100: '#FABFD2',
  50: '#FDE5ED',
}

export const success = {
  A200: '#43b658',
  A100: '#46bd66',
}

export const warning = {
  A200: '#f29f15',
  A100: '#f2a82a',
}

export const error = {
  A200: '#cb3939',
  A100: '#cf4b4a',
}

export const gray = {
  A200: '#dfdfe0',
  A100: '#d5d5d5',
}

export const white = {
  A200: '#F5F5F5',
  A100: '#EBEBEB',
}

export const palette = {
  primary: {
    main: primary[500],
    dark: primary[900],
    light: primary[100],
    ...primary,
  },
  secondary: {
    main: secondary[500],
    dark: secondary[900],
    light: secondary[100],
    ...secondary,
  },
  success: {
    main: '#00E676',
    dark: '#00C853',
    light: '#ECF9F3',
    contrastText: '#FFFFFF',
    ...success,
  },
  warning: {
    main: '#FFC107',
    dark: '#FFA000',
    light: '#FFF5E5',
    contrastText: '#FFFFFF',
    ...warning,
  },
  error: {
    main: '#E53935',
    dark: '#C62828',
    light: '#FCE7E7',
    ...error,
  },
  black: {
    main: 'rgba(0,0,0,0.87)',
    medium: 'rgba(0,0,0,0.60)',
    disabled: '#9E9E9E',
    inactive: 'rgba(0,0,0,0.54)',
    icons: 'rgba(0,0,0,0.87)',
  },
  white: {
    primary: 'rgba(255, 255, 255)',
    main: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    inactive: 'rgba(255, 255, 255, 0.54)',
    light: 'rgba(255, 255, 255, 0.32)',
    ...white,
  },
  gray: {
    dark: 'rgba(0,0,0,0.24)',
    medium: 'rgba(0,0,0,0.12)',
    light: 'rgba(0,0,0,0.04)',
    main: '#F5F5F5',
    divider: '#E5E5E5',
    outline: '#AFBDD1',
    inactive: '#D7D5D5',
    chipMedium: '#E0E0E0',
    chipLight: '#EBEBEB',
    ...gray,
  },
  backgroundStyle: {
    main: '#E8E8E8',
    dark: '#E8E8E8',
    light: '#FAFAFA',
    input: 'rgba(255,255,255,0.2)',
  },
  hoverOverlay: {
    main: 'rgba(0,0,0,0.08)',
    black: 'rgba(0,0,0,0.08)',
    blackLight: 'rgba(0,0,0,0.04)',
    white: 'rgba(255,255,255,0.08)',
    whiteLight: 'rgba(255,255,255,0.04)',
  },
  dark: {
    main: '#212936',
    black: '#212936',
    blackLight: '#2B3648',
    divider: '#313C4E',
    light: '#56657F',
    white: '#8997B1',
    whiteExtra: '#AFBDD1',
  },
}
